<template>
  <div class="page-container">
    
    <div class="data-filter">
      <el-button size="mini" type="primary" @click="dialogHandler()">공지 등록하기</el-button>
    </div>

    <div class="data-table">
      <el-table class="lmm-table" :data="list" v-loading="loading" @row-click="dialogHandler" stripe border>
        <el-table-column type="index" :index="rowIndex" width="120"></el-table-column>
        <el-table-column prop="notice_title" label="제목"></el-table-column>
      </el-table>
    </div>

    <div class="data-pagination">
      <el-pagination
        layout="prev, pager, next"
        :total="pagination.total"
        @current-change="pageHandler">
      </el-pagination>
    </div>

    <dialog-notice v-model="dialog_notice" :notice="dialog_notice_option" @close="submitHandler" />
  </div>
</template>

<script>
import DialogNotice from '@/components/Dialog-notice.vue'
export default {
  components: {DialogNotice},
  methods: {
    async getNotice () {
      console.log('GET NOTICE')
      try {
        this.loading = true
        let query = {
          order_by: [{ field: 'create_time', direction: 'desc' }]
        }
        let params = { results_per_page: this.pagination.limit, page: this.pagination.page, q: JSON.stringify(query)  }

        let response = await this.$http.get('notice', {params})
        this.pagination.total = response.data.num_results
        this.list = response.data.objects
        
        this.loading = false
        return response
      }
      catch (e) {
        console.error(e)
      }
    },
    rowIndex (index) {
      let {total, page, limit} = this.pagination
      let offset = (page - 1) * limit
      return total - (offset + index)
    },
    pageHandler (page) {
      this.pagination.page = page
      this.getNotice()
    },
    dialogHandler (params) {
      this.dialog_notice_option = params || null
      this.dialog_notice = true
    },
    async submitHandler (notice) {
      this.dialog_notice = false
      this.dialog_notice_option = null
      if (!notice) return;
      if (notice.pk) {
        let pk = notice.pk
        delete notice.pk
        delete notice.lang
        let {status} = await this.$http.put(`notice/${pk}`, notice)
        if (status === 200) {
          this.getNotice()
          this.$message.success('공지가 수정되었습니다')
          return status
        }
        else {
          this.$message.error('공지 수정에 실패하였습니다')
          return status
        }
      }
      else {
        delete notice.pk
        let {status} = await this.$http.post('notice', notice)
        if (status === 201) {
          this.getNotice()
          this.$message.success('공지가 등록되었습니다')
          return status
        }
        else {
          this.$message.error('공지 등록에 실패하였습니다')
          return status
        }
      }
    },
    rowClickHandler (row) {
      console.log(row)
    }
  },
  mounted () {
    this.getNotice()
  },
  data () {
    return {
      loading: false,
      filter: null,
      search: null,
      pagination: {
        total: 0,
        limit: 10,
        offset: 0,
        page: 1
      },
      list: [],
      dialog_notice: false,
      dialog_notice_option: null
    }
  }
}
</script>

<style lang="scss" scoped>
.manager-information {
  list-style: none;
  padding: 0; margin: 0;

  > li {
    padding: 4px 10px;
    > div { display: inline-block; }
    > .label {
      width: 160px;
      color: #a0a0a0;
    }
  }
}
.data-pagination {
  text-align: center;
  background-color: white;
  padding: 4px 10px;
}

.data-filter {
  padding: 10px 0;
  .data-filter-buttons {
    display: inline-block;
  }
  .data-filter-search {
    display: inline-block;
    padding-left: 15px;
  }
}
</style>
